import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface DownloadNotAvailableModalProps {
    isOpen: boolean;
    onClose: () => void;
}

/**
 * Modal component for displaying that downloads are not available for cases with tax year 2024 and earlier
 */
export const DownloadNotAvailableModal: React.FC<DownloadNotAvailableModalProps> = ({
    isOpen,
    onClose,
}) => {
    const theme = useTheme();

    if (!isOpen) return null;

    const styles = {
        modalOverlay: {
            position: 'fixed' as const,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
        },
        modalContent: {
            backgroundColor: theme.colors.surface,
            borderRadius: theme.borderRadius.lg,
            padding: '0',
            width: '50vw',
            maxWidth: '600px',
            boxShadow: theme.shadows.lg,
        },
        modalHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: `${theme.spacing.lg} ${theme.spacing.lg}`,
            borderBottom: `1px solid ${theme.colors.border.default}`,
            backgroundColor: theme.colors.primary,
        },
        modalTitle: {
            margin: 0,
            fontSize: theme.typography.fontSize.xl,
            fontWeight: theme.typography.fontWeight.semibold,
            color: theme.colors.text.inverse,
        },
        modalCloseButton: {
            background: 'none',
            border: 'none',
            fontSize: theme.typography.fontSize.xxl,
            color: theme.colors.text.inverse,
            cursor: 'pointer',
            padding: '0',
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: theme.borderRadius.sm,
        },
        modalBody: {
            padding: theme.spacing.lg,
            display: 'flex',
            flexDirection: 'column' as const,
            gap: theme.spacing.lg,
        },
        modalText: {
            margin: 0,
            fontSize: theme.typography.fontSize.lg,
            color: theme.colors.text.secondary,
            textAlign: 'center' as const,
        },
    };

    return (
        <div style={styles.modalOverlay} onClick={onClose}>
            <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <div style={styles.modalHeader}>
                    <h2 style={styles.modalTitle}>Download Not Available</h2>
                    <button
                        style={styles.modalCloseButton}
                        onClick={onClose}
                    >
                        ×
                    </button>
                </div>
                <div style={styles.modalBody}>
                    <p style={styles.modalText}>
                        PDFs for cases with tax year 2024 and earlier cannot be downloaded.
                    </p>
                </div>
            </div>
        </div>
    );
};
